/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandGitlab = createReactComponent("outline", "brand-gitlab", "IconBrandGitlab", [["path", { "d": "M21 14l-9 7l-9 -7l3 -11l3 7h6l3 -7z", "key": "svg-0" }]]);

export { IconBrandGitlab as default };
//# sourceMappingURL=IconBrandGitlab.mjs.map
